import {Avatar, DatePicker, Input, TimePicker} from 'antd'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import {FormActionGroups} from 'components/form/FormActionBar'
import {CustomToggleField} from 'components/form/fields/ToggleField'
import {WeekdaysField} from 'components/form/fields/WeekdaysField'
import {createSelectValue, createValue} from 'components/form/utils'
import {Formik, FormikConsumer} from 'formik'
import {formatDate, getDateString, parseDayjs} from 'helpers/datetimeHelpers'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {mapProps} from 'recompose'
import {SelectWidget} from 'views/AppLocals/custom/ReactSelectComponents'
import {getResponseItems, NullAsDefault, renderIf, shallowDiff} from 'views/Shared'
import LookupField from 'components/LookupField'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {HeaderWithIconLine} from 'views/AppLocals/Templates/items/ListHeader'
import {SubjectSelector} from 'views/AppLocals/Course/components/SubjectSelector'
import {TeacherSelector} from 'views/AppLocals/Course/components/TeacherSelector'
import {IoCalendarOutline} from 'react-icons/io5'
import Pure from 'components/Pure'
import dayjs from 'dayjs'
import {course_getCourseClassSubjects_Api, organization_getGroups_Api} from 'apis'
import useAsyncWithCache from 'modules/asyncCache/useAsyncWithCache'
import {IoIosTimer} from 'react-icons/io'
import TooltipApp from 'components/TooltipApp'
import {BsCaretDownFill, BsCaretRightFill, BsChevronRight, BsGeoAlt} from 'react-icons/bs'
import useToggle from 'react-use/lib/useToggle'
import {
    PiArrowFatLineRightFill,
    PiListNumbersBold,
    PiMapPinLineFill,
    PiPlusBold,
    PiUsersThreeFill,
    PiWarningCircleFill
} from 'react-icons/pi'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {createInputModal, showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import {ItemInformation} from 'components/common/ItemInformation'
import {FaUserTie} from 'react-icons/fa6'
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {ActionModalWrapper} from 'components/form/ActionModalWrapper'
import {GoDotFill} from 'react-icons/go'
import {RiMapPinTimeFill, RiStopCircleFill} from 'react-icons/ri'
import getTitle from 'helpers/getTitle'

const TimetableDetails = ({name, value, defaultValue = [], handleChange = NullAsDefault}) => {
    const t = useTranslate()
    const timetable_details = value || defaultValue;
    const [newValue, setNewValue] = useState({
        start_time: dayjs().set('hour', 8).set('minute', 0),
        end_time: dayjs().set('hour', 8).set('minute', 0),
        location_address: null,
        id: Date.now()
    })
    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 flex-1">
                    <div className="col-span-1 flex gap-3">
                        <DatePicker
                            allowClear={true}
                            showTime={true}
                            showSecond={false}
                            placeholder={t('Select date')}
                            format="DD/MM/YYYY - HH:mm"
                            suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                            defaultValue={dayjs().set('hour', 8).set('minute', 0)}
                            onChange={(dateObj) => {
                                if (dateObj) {
                                    setNewValue({...newValue, start_time: dateObj.utc().format('YYYY-MM-DDTHH:mm:ssZ')})
                                } else {
                                    setNewValue({...newValue, start_time: null})
                                }
                            }}
                            style={{fontSize: 12}}
                        />
                        <DatePicker
                            allowClear={true}
                            showTime={true}
                            showSecond={false}
                            placeholder={t('Select date')}
                            format="DD/MM/YYYY - HH:mm"
                            suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                            defaultValue={dayjs().set('hour', 8).set('minute', 0)}
                            onChange={(dateObj) => {
                                if (dateObj) {
                                    setNewValue({...newValue, end_time: dateObj.utc().format('YYYY-MM-DDTHH:mm:ssZ')})
                                } else {
                                    setNewValue({...newValue, end_time: null})
                                }
                            }}
                            style={{fontSize: 12}}
                        />
                    </div>
                    <div className="col-span-1 flex gap-3">
                        <Input
                            className="flex-1"
                            placeholder={t('enter note')}
                            onChange={(e) => {
                                setNewValue({...newValue, notes: e.target.value})
                            }}
                        />
                        <Avatar
                            size={32}
                            icon={<PiPlusBold size={15} className="text-primary"/>}
                            className="flex flex-center bg-primary-50 hover:bg-primary-100 rounded-md cursor-pointer"
                            onClick={() => {
                                let _timetable_details = _.cloneDeep(timetable_details);
                                _timetable_details.push(newValue);
                                handleChange(_timetable_details)
                                setTimeout(() => {
                                    setNewValue({
                                        start_time: dayjs().set('hour', 8).set('minute', 0),
                                        end_time: dayjs().set('hour', 8).set('minute', 0),
                                        location_address: null
                                    })
                                }, 1000)
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {timetable_details.map((timetable_detail, idx) => {
                    const {start_time, end_time, location_address, notes, is_holiday} = timetable_detail ?? {}
                    const isHappened = dayjs(start_time).isBefore(dayjs())

                    return (
                        <div key={idx} style={{padding: '6px 0'}}
                             className={classNames(
                                 "flex flex-col custom-item-render custom-render-border relative",
                                 isHappened && 'opacity-35'
                             )}>
                            <div style={{fontSize: 12}}
                                 className="font-bold text-color-000 capitalize tracking-wide leading-snug mr-6">
                                <span className="font-medium text-color-100 italic">
                                    {`${idx + 1}. ${parseDayjs(start_time)?.format("dddd")}, `}
                                </span>
                                {formatDate(start_time, "DD/MM/YYYY")}
                            </div>
                            {renderIf(
                                is_holiday === 0,
                                <DoubleValueItem
                                    showIcon={true}
                                    labelFirst="time"
                                    valueFirst={`${formatDate(start_time, 'HH:mm')} -> ${formatDate(end_time, 'HH:mm')}`}
                                    labelSecond={location_address ? 'in' : ''}
                                    valueSecond={
                                        <span className="font-semibold text-blue-500">
                                        {location_address}
                                    </span>
                                    }
                                    style={{fontSize: 11}}
                                    className="italic"
                                />
                            )}
                            {renderIf(
                                notes,
                                <ItemInformation
                                    showIcon={true}
                                    label="notes"
                                    value={
                                        <span className="font-semibold text-color-100 whitespace-pre-line">
                                            {notes}
                                        </span>
                                    }
                                    style={{fontSize: 11}}
                                    className="flex italic"
                                />
                            )}
                            <div className="absolute top-5 right-5 flex gap-2">
                                <BiSolidEdit
                                    size={13}
                                    className="text-blue-500 hover:text-blue-700 cursor-pointer contextIcon"
                                    onClick={() => {
                                        let _timetable_details = _.cloneDeep(timetable_details);
                                        const itemIndex = _timetable_details.findIndex(item => item.id === timetable_detail?.id);
                                        if (itemIndex !== -1) {
                                            createInputModal({
                                                title: 'add note',
                                                message: 'notes',
                                                placeholder: 'input your note',
                                                translate: t,
                                                value: _timetable_details[itemIndex]["notes"],
                                                onOk: (inputValue) => {
                                                    _timetable_details[itemIndex]["notes"] = inputValue;
                                                    handleChange(_timetable_details)
                                                },
                                            });
                                        }
                                    }}
                                />
                                <BiTrash
                                    size={13}
                                    className="text-primary-200 hover:text-primary-700 cursor-pointer contextIcon"
                                    onClick={() => {
                                        let _timetable_details = _.cloneDeep(timetable_details);
                                        showDeleteConfirmDialog({
                                            translate: t,
                                            title: 'delete lesson',
                                            message: 'are you sure you want to delete lesson',
                                            onOk: () => {
                                                _.remove(_timetable_details, {id: timetable_detail?.id});
                                                handleChange(_timetable_details)
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

// `organization` trong values có thể là bản OrganizationTransformerBasic (vd lấy qua Group->organization)
// nên KHÔNG có field `.groups` — luôn fetch riêng qua organization_getDepartments_Api theo id, không đọc
// values.organization.groups (mirror ParentDepartmentField trong OrganizationGroupForm.js).
const GroupInOrganizationField = ({name, value, onChange, form}) => {
    const t = useTranslate()
    const organization = _.get(form, 'values.organization')
    const org_id = getId(organization)

    const {response, isLoading} = useAsyncWithCache({
        cacheId: [organization_getGroups_Api.path, org_id].join('/'),
        apiInfo: organization_getGroups_Api,
        query: {id: org_id},
        once: true,
    })

    const options = useMemo(() => {
        const items = getResponseItems(response) || []
        return items.map((e) => ({
            value: e.id, label: `${e?.title} (${e?.member_count} ${t('members')})`
        }))
    }, [response, t])

    return (
        <SelectWidget
            name={name}
            allowClear={true}
            loading={isLoading}
            className="w-full"
            value={value || undefined}
            options={options}
            placeholder={t('---Choose One---')}
            onChange={(v) => onChange(createSelectValue('group_id', v))}
        />
    )
}

// `values.courseOwnerId`/`values.courseOwnerType` (course_class only) là owner CỦA COURSE_CLASS
// (vd organization sở hữu khóa học, dùng để filter Teacher/Subject) — cố tình đặt tên khác
// `owner_type`/`owner_id` (Timetable thuộc về organization hay course_class, do useTimetableOrganizationForm/
// useTimetableCourseClassForm tự thêm khi gọi API) để không bao giờ đụng field, tránh leak nhầm giá trị.
const formSchema = {
    title: {
        title: 'title',
        children: [
            {
                name: 'title',
                component: createControlledFormField({placeholder: 'title'}),
            },
        ],
    },
    phase: {
        title: 'phase title',
        description: 'phase title sort hint',
        children: [
            {
                name: 'phase_title',
                component: createControlledFormField({placeholder: 'phase title placeholder'}),
            },
        ],
    },
    from_to_date: {
        inline: true,
        description: 'timetable display period',
        className: "grid grid-cols-2 gap-3",
        children: [
            {
                label: 'from date',
                name: 'from_date',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <DatePicker
                                allowClear={true}
                                showTime={false}
                                className="w-full"
                                placeholder={t('Select date')}
                                format="DD/MM/YYYY"
                                suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                defaultValue={value ?? undefined}
                                onChange={(value) => onChange(createValue(name, value))}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'to date',
                name: 'to_date',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <DatePicker
                                showTime={false}
                                showSecond={false}
                                className="w-full"
                                placeholder={t('Select date')}
                                allowClear={true}
                                format="DD/MM/YYYY"
                                suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                defaultValue={value ?? undefined}
                                onChange={(value) => onChange(createValue(name, value))}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    days_of_week: {
        title: 'day of week',
        description: 'recurring days of the week',
        children: [
            {
                name: 'days_of_week',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: WeekdaysField,
                    withProps: ({name, value, onChange}) => ({
                        defaultValue: value,
                        onChange: (_value) => onChange(createValue(name, _value)),
                    }),
                    withValues: ({resetKey}) => ({resetKey}),
                }),
            },
        ],
    },
    from_to_time: {
        inline: true,
        description: 'recurring session time',
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'start time',
                name: 'from_time',
                component: ({name, value, onChange}) => (
                    <TimePicker
                        className="w-full"
                        allowClear={true}
                        placeholder="07:00"
                        format="HH:mm"
                        suffixIcon={<IoIosTimer className="text-color-500"/>}
                        defaultValue={value ? dayjs(value, 'HH:mm') : undefined}
                        onChange={(value) => onChange(createValue(name, value))}
                    />
                ),
            },
            {
                label: 'end time',
                name: 'to_time',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {() => (
                            <TimePicker
                                className="w-full"
                                placeholder="12:00"
                                allowClear={false}
                                format="HH:mm"
                                suffixIcon={<IoIosTimer className="text-color-500"/>}
                                defaultValue={value ? dayjs(value, 'HH:mm') : undefined}
                                onChange={(value) => onChange(createValue(name, value))}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    location_address: {
        title: 'locations',
        children: [
            {
                name: 'location_address',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    // organization: owner lấy từ values.organization. group: owner lấy từ values.group
                    // (standalone group, không thuộc organization). course_class: cả 2 field trên không
                    // tồn tại nên fallback sang values.courseOwnerType/courseOwnerId (owner của
                    // course_class, do Creation/Editing/Copy modal set sẵn — cùng field TeacherSelector đọc).
                    const organizationOwner = _.get(values, 'organization', {})
                    const groupOwner = _.get(values, 'group', {})
                    const owner_type = getType(organizationOwner) || getType(groupOwner) || values?.courseOwnerType;
                    const owner_id = organizationOwner?.id || groupOwner?.id || values?.courseOwnerId;
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={true}
                                    defaultValue={values?.location_address}
                                    apiPath={`/lookup/${owner_type}/${owner_id}/field/location_address/gets`}
                                    name={name}
                                    placeholder={t('choose or create address')}
                                    handleChange={(e) => onChange(createValue('location_address', e.target.value))}
                                    OptionWrapper={({children, ...props}) =>
                                        <div className="lookup-item"
                                            {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => (
                                        <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                            <Avatar
                                                size={50}
                                                className="flex flex-center bg-secondary-100 rounded-xl"
                                                icon={<BsGeoAlt size={20} className="text-secondary"/>}
                                            />
                                            <div className="flex flex-col gap-1 flex-1">
                                                <span className="font-bold text-sm text-color-000 leading-snug">
                                                    {o.label}
                                                </span>
                                            </div>
                                            <BsChevronRight size={16} className="text-color-500"/>
                                        </div>
                                    )}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    teacher: {
        title: 'teacher',
        children: [
            {
                name: 'teacher',
                component: mapProps(({name, value, form, onChange}) => {
                    const {courseOwnerId, courseOwnerType} = form?.values ?? {}
                    return {name, value, onChange, owner_id: courseOwnerId, owner_type: courseOwnerType}
                })(TeacherSelector),
            },
        ],
    },
    subject: {
        title: 'subjects',
        children: [
            {
                name: 'subject',
                component: mapProps(({name, value, form, onChange}) => ({
                    name,
                    value,
                    onChange,
                    course_id: form?.values?.course_id,
                    customConfigs: {
                        apiInfo: course_getCourseClassSubjects_Api,
                        query: bindQueryParam({id: form?.values?.course_class_id}),
                    }
                }))(SubjectSelector),
            },
        ],
    },
    department_in_organization: {
        description: 'which group or ministry this timetable belongs to',
        children: [
            {
                name: 'group_id',
                component: GroupInOrganizationField,
            },
        ],
    },
    timetable_details: {
        children: [
            {
                name: 'timetable_details',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: TimetableDetails,
                    withProps: ({name, value, onChange}) => ({
                        defaultValue: value,
                        handleChange: (_value) => onChange(createValue(name, _value)),
                    }),
                    withValues: ({resetKey}) => ({resetKey}),
                }),
            },
        ],
    },
    notes: {
        title: 'notes',
        children: [
            {
                name: 'notes',
                component: createControlledFormField({
                    rows: 3,
                    className: 'w-full',
                    placeholder: 'notes',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
}

const validate = (values, t) => {
    let errors = {}
    const {from_date, to_date, from_time, to_time, is_holiday} = values ?? {}

    if (!from_date) errors.from_date = t('required field')
    if (!to_date) errors.to_date = t('required field')
    if (from_date && to_date && dayjs(to_date).isBefore(dayjs(from_date), 'day')) {
        errors.to_date = t('end date must be same as or after start date')
    }
    if (is_holiday === 0 && !from_time) errors.from_time = t('required field')
    if (is_holiday === 0 && !to_time) errors.to_time = t('required field')

    return errors
}

const commonFieldsBlock = (isCourseClass) => (
    <div className="flex flex-col gap-2">
        <HeaderWithIconLine
            icon={<PiWarningCircleFill size={15} className="text-color-500"/>}
            title="basic information"
            className="text-base text-color-300"
        />
        <div className="flex flex-col gap-3">
            <FieldsFactory formSchema={[isCourseClass ? formSchema.phase : formSchema.title]}/>
            <FieldsFactory formSchema={[formSchema.from_to_date]}/>
        </div>
    </div>
)

const GroupSectionHeader = () => (
    <HeaderWithIconLine
        icon={<PiUsersThreeFill size={15} className="text-color-500"/>}
        title="choose group / ministry"
        className="text-base text-color-300"
    />
)

const timeLocationBlock = () => (
    <Pure>
        <FieldsFactory formSchema={[formSchema.from_to_time]}/>
        <FieldsFactory formSchema={[formSchema.days_of_week]}/>
        <FieldsFactory formSchema={[formSchema.location_address]}/>
    </Pure>
)

// Header ghép 2 từ dịch ("time" + "locations") nên cần render-prop Translate thay vì
// title string đơn — dùng chung cho cả 3 modal (Creation/Editing/Copy) để tránh lặp code.
const timeLocationSection = () => (
    <div className="flex flex-col gap-2 pt-4">
        <HeaderWithIconLine
            renderTitle={() => (
                <div className="flex items-center gap-1">
                    <PiMapPinLineFill size={15} className="text-color-500"/>
                    <Translate>
                        {(t) => (
                            <span className="font-bold text-base text-color-300 uppercase tracking-wider">
                                {`${t('time')} / ${t('locations')}`}
                            </span>
                        )}
                    </Translate>
                </div>
            )}
        />
        {timeLocationBlock()}
    </div>
)

const subjectTeacherSection = () => (
    <div className="flex flex-col gap-2 pt-4">
        <HeaderWithIconLine
            renderTitle={() => (
                <div className="flex items-center gap-1">
                    <FaUserTie size={15} className="text-color-500"/>
                    <Translate>
                        {(t) => (
                            <span className="font-bold text-base text-color-300 uppercase tracking-wider">
                                {`${t('subjects')} / ${t('teachers')}`}
                            </span>
                        )}
                    </Translate>
                </div>
            )}
        />
        <FieldsFactory formSchema={[formSchema.subject, formSchema.teacher, formSchema.notes]}/>
    </div>
)

const groupSection = () => (
    <div className="flex flex-col gap-2 pt-4">
        <GroupSectionHeader/>
        <FieldsFactory formSchema={[formSchema.department_in_organization]}/>
    </div>
)

const notesSection = () => (
    <div className="flex flex-col gap-2 pt-4">
        <FieldsFactory formSchema={[formSchema.notes]}/>
    </div>
)

// Ngày nghỉ là trường hợp đặc biệt, ít dùng — đặt cuối form kèm giải thích rõ,
// thay vì nằm ngay đầu cạnh tựa đề như trước (dễ gây hiểu lầm là trường bắt buộc quan tâm).
const holidaySection = () => (
    <FormikConsumer>
        {({values, setFieldValue}) => (
            <div className="flex flex-col gap-2 pt-4">
                <HeaderWithIconLine
                    icon={<RiStopCircleFill size={15} className="text-color-500"/>}
                    title="special case"
                    className="text-base text-color-300"
                />
                <CustomToggleField
                    Icon={RiStopCircleFill}
                    title="holiday"
                    description="holiday description"
                    className="p-3 border border-dashed border-color-200 rounded-xl"
                    value={!!values.is_holiday}
                    onChange={(checked) => setFieldValue('is_holiday', Number(checked))}
                />
            </div>
        )}
    </FormikConsumer>
)

export const TimetableCreationModal = ({
                                           owner_type,
                                           organization,
                                           group,
                                           defaultGroupId,
                                           course_id,
                                           course_class_id,
                                           courseOwnerType,
                                           courseOwnerId,
                                           onSubmit = NullAsDefault,
                                       }) => {
    const t = useTranslate()
    const isCourseClass = owner_type === 'course_class'
    // owner_type='organization': timetable của 1 department trong org, cần picker chọn group/ministry con.
    // owner_type='group': timetable của 1 group độc lập (không thuộc org) - context group đã cố định,
    // không cần picker.
    const isDepartmentOfOrganization = owner_type === 'organization'
    const [resetKey, setResetKey] = useState();

    const initialValues = useMemo(() => {
        const base = {
            from_date: undefined, to_date: undefined,
            from_time: undefined, to_time: undefined,
            days_of_week: '0000000',
            is_holiday: 0,
        }
        switch (owner_type) {
            case 'course_class':
                return {
                    ...base,
                    course_id,
                    course_class_id,
                    courseOwnerId,
                    courseOwnerType,
                    teacher: undefined,
                    subject: undefined,
                }
            case 'group':
                return {
                    ...base,
                    group,
                }
            case 'organization':
            default:
                return {
                    ...base,
                    organization,
                    group_id: defaultGroupId,
                }
        }
    }, [owner_type, courseOwnerType, courseOwnerId, organization, group, defaultGroupId, course_id, course_class_id])

    return (
        <Formik
            onSubmit={(values) => {
                const {subject, teacher, courseOwnerId, courseOwnerType, organization, group, from_date, to_date, from_time, to_time, ...rest} = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            from_date: getDateString(from_date),
                            to_date: getDateString(to_date),
                            from_time: from_time ? dayjs(from_time).format("HH:mm") : null,
                            to_time: to_time ? dayjs(to_time).format("HH:mm") : null,
                            ...(isCourseClass ? {
                                teacher_id: values?.teacher ? getId(teacher) : null,
                                subject_id: values?.subject ? getId(subject) : null,
                            } : {
                                organization_id: getId(organization),
                            }),
                        },
                        _.isUndefined
                    )
                )
            }}
            onReset={() => setResetKey(Date.now())}
            validate={(values) => validate(values, t)}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <ActionModalWrapper action={<FormActionGroups submitProps={{label: 'add'}}/>}>
                <Pure input={[resetKey]}>
                    {commonFieldsBlock(isCourseClass)}
                    {isDepartmentOfOrganization && groupSection()}
                    {timeLocationSection()}
                    {isCourseClass ? subjectTeacherSection() : notesSection()}
                    {holidaySection()}
                </Pure>
            </ActionModalWrapper>
        </Formik>
    )
}

export const TimetableEditingModal = ({
                                          owner_type,
                                          organization,
                                          group,
                                          course_id,
                                          course_class_id,
                                          courseOwnerType,
                                          courseOwnerId,
                                          item,
                                          onSubmit = NullAsDefault,
                                      }) => {
    const t = useTranslate()
    const isCourseClass = owner_type === 'course_class'
    const isDepartmentOfOrganization = owner_type === 'organization'
    const [isToggle, toggle] = useToggle(true)

    const initialValues = useMemo(() => {
        const {from_date, to_date, ...rest} = item ?? {}
        const base = {
            ...rest,
            from_date: parseDayjs(from_date),
            to_date: parseDayjs(to_date),
        }
        switch (owner_type) {
            case 'course_class':
                return {
                    ...base,
                    course_id,
                    course_class_id,
                    courseOwnerId,
                    courseOwnerType,
                }
            case 'group':
                return {
                    ...base,
                    group: rest?.group ?? group,
                }
            case 'organization':
            default:
                return {
                    ...base,
                    group_id: rest?.group?.id,
                    organization,
                }
        }
    }, [owner_type, courseOwnerType, courseOwnerId, organization, group, course_id, course_class_id, item])

    return (
        <Formik
            onSubmit={(values) => {
                const changes = shallowDiff(values, initialValues)
                const {subject, teacher, courseOwnerId, courseOwnerType, organization, group, from_date, to_date, from_time, to_time, timetable_details, ...rest} = changes ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            from_date: getDateString(from_date),
                            to_date: getDateString(to_date),
                            from_time: !!from_time ? dayjs(from_time).format("HH:mm") : undefined,
                            to_time: !!to_time ? dayjs(to_time).format("HH:mm") : undefined,
                            timetable_details: JSON.stringify(timetable_details),
                            ...(isCourseClass ? {
                                teacher_id: values?.teacher ? getId(teacher) : null,
                                subject_id: values?.subject ? getId(subject) : null,
                            } : {}),
                        },
                        _.isUndefined
                    )
                )
            }}
            validate={(values) => validate(values, t)}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <ActionModalWrapper action={<FormActionGroups submitProps={{label: 'save'}}/>}>
                <div className="flex flex-col gap-3">
                    <HeaderWithIconLine
                        icon={<PiWarningCircleFill size={15} className="text-color-500"/>}
                        title="basic information"
                        className="text-base text-color-300"
                        extra={
                            <TooltipApp title={t('click to expand')} placement="bottomRight"
                                        classNames={{root: "text-xs italic"}}>
                                <Avatar
                                    size={22}
                                    className="flex flex-center bg-blue-100 hover:bg-blue-200 rounded-xs cursor-pointer"
                                    icon={isToggle ? <BsCaretDownFill size={12} className="text-blue-600"/> :
                                        <BsCaretRightFill size={12} className="text-blue-600"/>}
                                    onClick={() => toggle()}
                                />
                            </TooltipApp>
                        }
                    />
                    {isToggle && (
                        <Pure>
                            <FieldsFactory formSchema={[isCourseClass ? formSchema.phase : formSchema.title]}/>
                            <FieldsFactory formSchema={[formSchema.from_to_date]}/>
                        </Pure>
                    )}
                </div>
                {isDepartmentOfOrganization && groupSection()}
                {timeLocationSection()}
                {isCourseClass && subjectTeacherSection()}
                {!isCourseClass && notesSection()}
                <div className="flex flex-col gap-2 pt-4">
                    <HeaderWithIconLine
                        icon={<PiListNumbersBold size={15} className="text-color-500"/>}
                        title={`${t('detail')} ${t('timetables')}`}
                        className="text-base text-color-300"
                    />
                    <FieldsFactory formSchema={[formSchema.timetable_details]}/>
                </div>
                {holidaySection()}
            </ActionModalWrapper>
        </Formik>
    )
}

export const TimetableCopyModal = ({
                                       owner_type,
                                       organization,
                                       group,
                                       course_id,
                                       course_class_id,
                                       courseOwnerType,
                                       courseOwnerId,
                                       item,
                                       onSubmit = NullAsDefault,
                                   }) => {
    const t = useTranslate()
    const isCourseClass = owner_type === 'course_class'
    const isDepartmentOfOrganization = owner_type === 'organization'
    const [isToggle, toggle] = useToggle(true);

    const initialValues = useMemo(() => {
        const {id, from_date, to_date, ...rest} = item ?? {}
        const base = {
            ...rest,
            from_date: parseDayjs(from_date),
            to_date: parseDayjs(to_date),
        }
        switch (owner_type) {
            case 'course_class':
                return {
                    ...base,
                    subject_id: rest?.subject?.id,
                    course_id,
                    course_class_id,
                    courseOwnerId,
                    courseOwnerType,
                }
            case 'group':
                return {
                    ...base,
                    group: rest?.group ?? group,
                }
            case 'organization':
            default:
                return {
                    ...base,
                    group_id: rest?.group?.id,
                    organization,
                }
        }
    }, [owner_type, courseOwnerType, courseOwnerId, organization, group, course_id, course_class_id, item])

    return (
        <Formik
            onSubmit={(values) => {
                const {subject, teacher, courseOwnerId, courseOwnerType, organization, group, from_date, to_date, from_time, to_time, timetable_details, ...rest} = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            from_date: getDateString(from_date),
                            to_date: getDateString(to_date),
                            from_time: !!from_time ? dayjs(from_time, "HH:mm").format("HH:mm") : undefined,
                            to_time: !!to_time ? dayjs(to_time, "HH:mm").format("HH:mm") : undefined,
                            timetable_details: JSON.stringify(timetable_details),
                            ...(isCourseClass ? {
                                teacher_id: values?.teacher ? getId(teacher) : null,
                                subject_id: values?.subject ? getId(subject) : null,
                            } : {
                                organization_id: getId(organization),
                            }),
                        },
                        _.isUndefined
                    )
                )
            }}
            validate={(values) => validate(values, t)}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <ActionModalWrapper action={<FormActionGroups submitProps={{label: 'create new'}}/>}>
                <div className="flex flex-col gap-3">
                    <HeaderWithIconLine
                        icon={<PiWarningCircleFill size={15} className="text-color-500"/>}
                        title="basic information"
                        className="text-base text-color-300"
                        extra={
                            <TooltipApp title={t('click to expand')} placement="bottomRight"
                                        classNames={{root: "text-xs italic"}}>
                                <Avatar
                                    size={22}
                                    className="flex flex-center bg-blue-100 hover:bg-blue-200 rounded-xs cursor-pointer"
                                    icon={isToggle ? <BsCaretDownFill size={12} className="text-blue-600"/> :
                                        <BsCaretRightFill size={12} className="text-blue-600"/>}
                                    onClick={() => toggle()}
                                />
                            </TooltipApp>
                        }
                    />
                    {isToggle && (
                        <Pure>
                            <FieldsFactory formSchema={[isCourseClass ? formSchema.phase : formSchema.title]}/>
                            <FieldsFactory formSchema={[formSchema.from_to_date]}/>
                        </Pure>
                    )}
                </div>
                {isDepartmentOfOrganization && groupSection()}
                {timeLocationSection()}
                {isCourseClass ? subjectTeacherSection() : notesSection()}
                {holidaySection()}
            </ActionModalWrapper>
        </Formik>
    )
}

export const renderTimetableItem = ({renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {group, from_date, to_date, title, timetable_details = [], location_address, notes, is_holiday, phase_title, subject, teacher} = item ?? {}

    const displayTitle = phase_title ?? title

    function getNextLesson(timetables) {
        const currentDate = dayjs();
        const futureDays = timetables.filter(day => dayjs(day.start_time).isAfter(currentDate));
        if (futureDays.length === 0) return false
        return futureDays.reduce((nearest, day) => {
            return dayjs(day.start_time).isBefore(dayjs(nearest.start_time)) ? day : nearest;
        }).start_time;
    }

    let one_day = formatDate(from_date, 'DD/MM/YYYY') === formatDate(to_date, 'DD/MM/YYYY')

    let is_finished = one_day
        ? dayjs(from_date).isBefore(dayjs())
        : getNextLesson(timetable_details) === false

    const TitleLesson = ({day}) => {
        const t = useTranslate()
        return (
            <span className="space-x-1 text-xs italic leading-snug">
                <span className="text-color-500 whitespace-no-wrap">{`${t('schedule')} : `}</span>
                {renderIf(
                    !one_day,
                    <span className="font-bold text-blue-600">
                        {`${_.capitalize(formatDate(day, 'dddd'))}, ${formatDate(day, "DD/MM/YYYY")} `}
                    </span>
                )}
                {renderIf(
                    location_address,
                    <span className="mx-1 text-color-500 whitespace-no-wrap">{t('in')}</span>
                )}
                {renderIf(
                    location_address,
                    <span className="font-semibold text-color-100">{location_address}</span>
                )}
            </span>
        )
    }

    return (
        <Translate key={index}>
            {(t) => (
                <div className={classNames(
                    "p-3 flex flex-col gap-1 custom-item-render relative list-item",
                    is_finished && 'opacity-60'
                )}>
                    <div className="flex flex-col gap-x-1">
                        <div className={classNames(
                            "mb-2 flex items-center gap-1 leading-tight mr-6",
                            is_finished
                                ? 'px-2 py-1.5 rounded-lg background-100'
                                : 'pb-2 border-b border-color-50'
                        )}>
                            {is_holiday === 1
                                ? <RiStopCircleFill size={15} className="text-primary-500"/>
                                : <RiMapPinTimeFill size={15} className={is_finished ? 'text-color-500' : 'text-green-500'}/>}
                            {one_day ? (
                                <ItemInformation
                                    primary={true}
                                    colon={false}
                                    label="date"
                                    value={formatDate(from_date, 'DD/MM/YYYY')}
                                    className="text-sm italic"
                                />
                            ) : (
                                <DoubleValueItem
                                    primary={true}
                                    colon={false}
                                    labelFirst="from date"
                                    valueFirst={formatDate(from_date, 'DD/MM/YYYY')}
                                    labelSecond={to_date ? 'to date' : ''}
                                    valueSecond={formatDate(to_date, 'DD/MM/YYYY')}
                                    className="text-sm italic"
                                />
                            )}
                        </div>

                        {displayTitle !== null && (
                            <span className="font-bold text-sm text-gray-700 tracking-wide">
                                {displayTitle}
                            </span>
                        )}
                        {is_holiday === 1 ? (
                            <div className="ml-3 mt-1 flex flex-col">
                                <div className="flex items-center gap-3">
                                    <PiArrowFatLineRightFill size={11} className="text-primary-300"/>
                                    <span className="font-medium text-xs text-primary-400 italic tracking-widest">
                                        {t('holiday')}
                                    </span>
                                </div>
                                {renderIf(
                                    notes,
                                    <div className="flex items-start gap-1 text-xs italic">
                                        <span className="flex items-center gap-1 text-color-500 whitespace-no-wrap">
                                            <GoDotFill size={10} className="text-color-500"/>
                                            {`${t('note')} : `}
                                        </span>
                                        <span className="font-semibold text-color-100 whitespace-pre-line">
                                            {notes}
                                        </span>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div style={{marginLeft: 2, marginTop: 2}} className="flex flex-col gap-1">
                                <div className="space-x-1 leading-snug">
                                    {is_finished
                                        ? <PiArrowFatLineRightFill size={11} className="text-primary-600"/>
                                        : <GoDotFill size={10} className="text-color-400"/>}
                                    {is_finished
                                        ? <span className="font-bold text-xs text-primary-600 italic">{t('finished')}</span>
                                        : <TitleLesson day={getNextLesson(timetable_details)}/>}
                                </div>
                                {group && (
                                    <ItemInformation
                                        showIcon={true}
                                        label="group / ministry type"
                                        value={getTitle(group)}
                                        className="text-xs italic"
                                    />
                                )}
                                {teacher && (
                                    <ItemInformation
                                        showIcon={true}
                                        label="teacher"
                                        value={`${teacher?.prefix_title || ''} ${teacher?.fullname || getTitle(teacher)}`}
                                        className="text-xs italic"
                                    />
                                )}
                                {subject && (
                                    <ItemInformation
                                        showIcon={true}
                                        label="subjects"
                                        value={getTitle(subject)}
                                        className="text-xs italic"
                                    />
                                )}
                                {renderIf(
                                    notes,
                                    <div className="flex items-start gap-1 text-xs italic">
                                        <span className="flex items-center gap-1 text-color-500 whitespace-no-wrap">
                                            <GoDotFill size={10} className="text-color-500"/>
                                            {`${t('note')} : `}
                                        </span>
                                        <span className="font-semibold text-color-100 whitespace-pre-line">
                                            {notes}
                                        </span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="absolute top-5 right-5 contextIcon">
                        {renderContextMenu(item)}
                    </div>
                </div>
            )}
        </Translate>
    )
}
